import React, { useEffect, useState } from 'react';
import { ActivityIndicator, ScrollView, View } from "react-native"
import Colors from '../../constants/Colorsv2';
import { PlayerCommissionRebateProps } from '../../store/types/mk_svc';
import { Text, TouchableOpacity } from '../../globalComponents/NativeOverrides';
import { market_collectRebate, market_getPlayerCommissionRebateById } from '../../store/actionsv1/markets';
import moment from 'moment';
import { CashIcon, LightBulb, SavingsIcon } from '../../Componentsv1/Icons';
import { useSelector } from 'react-redux';


const ActivityRebateScreen = ({route, navigation}:any) => {
    const [ loading, setLoading ] = useState(false);
    const [ action_loading, setActionLoading ] = useState(false);
    const [ player_commission_rebate, setPlayerCommissionRebate ] = useState<PlayerCommissionRebateProps|undefined>(undefined);
    //const [ details_expanded, setDetailsExpanded ] = useState(false);
    
    const player = useSelector((state:any) => state.player.player, (left, right) => left?.updated == right?.updated);

    useEffect(() => {
        if(!route.params?.player_commission_rebate_id){ return }
        getDataFromServer(route.params.player_commission_rebate_id)
    },[route.params?.player_commission_rebate_id])

    const getDataFromServer = async(id:string) => {
        setLoading(true);
        const player_commission_rebate = await market_getPlayerCommissionRebateById(id)
        setPlayerCommissionRebate(player_commission_rebate)
        setLoading(false);
    }

    const collectRebate = async(player_commission_rebate_id:string) => {
        if(action_loading){ return } //No button mashing
        setActionLoading(true);
        const updated_rebate = await market_collectRebate(player_commission_rebate_id)
        if(!updated_rebate){
            alert('Unable to process')
            setActionLoading(false)
            return
        }
        setPlayerCommissionRebate(updated_rebate)
        setActionLoading(false);
    }

    let premium_rebate = 0;
    let freemium_rebate = 0;
    let rebate_difference = 0
    if(player_commission_rebate){
        premium_rebate = Math.min(player_commission_rebate.commission_paid, 11.25)
        freemium_rebate = Math.min(player_commission_rebate.commission_paid, 1.50)
        rebate_difference = premium_rebate - freemium_rebate
    }

    return (
        <View style={{ flex:1 }}>
            <ScrollView style={{ flex:1 }}>
                {loading ? 
                <ActivityIndicator style={{ padding:20, alignSelf: 'center' }} size='large' color={Colors.brand.midnight} />
                :<></>}
                {player_commission_rebate ?
                <View style={{ flex:1 }}>
                    {false ?
                    <View nativeID='rebate_amt' style={{ margin:10, backgroundColor:Colors.highlights.highlight400Faded, padding:10, borderRadius:8 }}>
                        <Text size={16} color={Colors.brand.midnight} weight='bold' textAlign='center'>REBATE AVAILABLE NOW</Text>
                        <Text style={{ marginTop:5 }} size={14} color={Colors.brand.midnight} weight='semibold' textAlign='center'>{moment.utc(player_commission_rebate.rebate_month).format('MMMM YYYY')}</Text>
                        <Text style={{ marginTop:5 }} size={30} color={Colors.utility.success} weight='bold' textAlign='center'>${player_commission_rebate.rebate_amt.toFixed(2)}</Text>
                    </View>
                    :<></>}
                    <View nativeID='rebate_details' style={{ backgroundColor:Colors.shades.shade200, padding:10, borderRadius:8, margin:10 }}>
                        <View style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderBottomColor:Colors.shades.shade600 }}>
                            <Text style={{ flex:1 }} size={16} color={Colors.brand.midnight} weight='bold'>Rebate Details</Text>
                            <Text size={14} color={Colors.brand.midnight} weight='regular'>{moment.utc(player_commission_rebate.rebate_month).format('MMMM YYYY')}</Text>
                        </View>
                        <View style={{ padding:10 }}>
                            <View style={{ padding:5 }}>
                                <Text size={14} color={Colors.brand.slate}>Calculated using: Lessor of Charges Paid and Rebate Cap</Text>
                            </View>
                            <View nativeID='detail_row' style={{ flexDirection:'row', alignItems:'center', padding:5 }}>
                                <Text style={{ flex:1 }} size={14} color={Colors.brand.midnight}>Charges Paid</Text>
                                <Text size={14} color={Colors.brand.slate} weight='bold'>${player_commission_rebate.commission_paid.toFixed(2)}</Text>
                            </View>
                            <View nativeID='detail_row' style={{ flexDirection:'row', alignItems:'center', padding:5 }}>
                                <Text style={{ flex:1 }} size={14} color={Colors.brand.midnight}>Rebate Cap</Text>
                                <Text size={14} color={Colors.brand.slate} weight='bold'>${player_commission_rebate.rebate_cap.toFixed(2)}</Text>
                            </View>
                            <View nativeID='detail_row' style={{ flexDirection:'row', alignItems:'center', padding:5,  paddingBottom:10, borderBottomWidth:1, borderBottomColor:Colors.shades.shade600  }}>
                                <Text style={{ flex:1 }} size={14} color={Colors.brand.midnight}>Expires</Text>
                                {player_commission_rebate.status != 'collected' ?
                                <Text size={14} color={Colors.brand.slate} weight='bold'>{moment(player_commission_rebate.expire_datetime).format('MM/DD/YYYY @ hh:mm a')}</Text>
                                :
                                <Text size={14} color={Colors.brand.slate} weight='bold'>NA - CLAIMED</Text>
                                }
                            </View>
                            <View nativeID='detail_row' style={{ flexDirection:'row', alignItems:'center', padding:5, paddingTop:10 }}>
                                <Text style={{ flex:1 }} size={14} color={Colors.brand.midnight} weight='bold'>Rebate Available</Text>
                                <Text size={20} color={Colors.utility.success} weight='bold'>${player_commission_rebate.rebate_amt.toFixed(2)}</Text>
                            </View>
                            <Text size={12} color={Colors.brand.slate} textAlign='right'>Rebate expires 30 days after issued</Text>
                        </View>
                    </View>
                    <View nativeID='rebate_details' style={{ backgroundColor:Colors.shades.shade200, padding:10, borderRadius:8, margin:10 }}>
                        <View style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderBottomColor:Colors.shades.shade600 }}>
                            <View style={{ flex:1, marginRight:10, flexDirection:'row', alignItems:'center' }}>
                                <SavingsIcon size={20} color={Colors.utility.success} />
                                <Text style={{ marginLeft:10 }} size={14} color={Colors.brand.midnight} weight='bold'>Community Vig Saved</Text>
                            </View>
                            <Text size={14} color={Colors.brand.midnight} weight='bold'>${player_commission_rebate.community_saved.toFixed(2)}</Text>
                        </View>
                        <View style={{ padding:10 }}>
                            <Text size={14} color={Colors.brand.midnight} weight='regular'>Based on your volume this month, you saved approximately ${player_commission_rebate.community_saved.toFixed(2)} for the community by betting with NO VIG on BettorEdge.</Text>
                        </View>
                    </View>
                </View>
                :<></>}
                {player_commission_rebate && player?.type == 'premium' && rebate_difference > 0 ?
                <View nativeID='premium_rebate_info' style={{ backgroundColor:Colors.incentive.gold_faded, padding:10, borderRadius:8, margin:10 }}>
                    <View style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderBottomColor:Colors.shades.shade600 }}>
                        <View style={{ flex:1, marginRight:10, flexDirection:'row', alignItems:'center' }}>
                            <LightBulb size={18} color={Colors.utility.warning} />
                            <Text style={{ marginLeft:10 }} size={14} color={Colors.brand.midnight} weight='bold'>Did you know</Text>
                        </View>
                        <Text size={14} color={Colors.brand.midnight} weight='bold'>${rebate_difference.toFixed(2)}</Text>
                    </View>
                    <View style={{ padding:10 }}>
                        <Text size={14} color={Colors.brand.midnight} weight='regular'>Because you are a premium member, your rebate is ${rebate_difference.toFixed(2)} higher!</Text>
                    </View>
                </View>
                : player_commission_rebate && player?.type == 'freemium' && rebate_difference > 0 ?
                <View nativeID='premium_rebate_info' style={{ backgroundColor:Colors.incentive.gold_faded, padding:10, borderRadius:8, margin:10 }}>
                    <View style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderBottomColor:Colors.shades.shade600 }}>
                        <View style={{ flex:1, marginRight:10, flexDirection:'row', alignItems:'center' }}>
                            <LightBulb size={18} color={Colors.utility.warning} />
                            <Text style={{ marginLeft:10 }} size={14} color={Colors.brand.midnight} weight='bold'>Did you know</Text>
                        </View>
                        <Text size={14} color={Colors.brand.midnight} weight='bold'>${premium_rebate.toFixed(2)}</Text>
                    </View>
                    <View style={{ padding:10 }}>
                        <Text size={14} color={Colors.brand.midnight} weight='regular'>Premium members have a higher rebate cap than freemium members, if you were premium, your rebate would have been ${premium_rebate.toFixed(2)}!</Text>
                    </View>
                    <TouchableOpacity style={{ borderRadius:22, backgroundColor:Colors.incentive.gold, padding:15, margin:10}} onPress={() => navigation.navigate('AuthStack', { screen: 'Premium' })}>
                        <Text size={14} color={Colors.shades.white} textAlign='center' weight='bold'>VIEW PREMIUM</Text>
                    </TouchableOpacity>
                </View>
                :<></>}
            </ScrollView>
            {player_commission_rebate?.status == 'collectable' ?
            <View style={{ flexDirection:'row', margin:10 }}>
                {false ?
                <TouchableOpacity style={{ flex:1, marginRight:5, padding:15, backgroundColor:Colors.brand.electric, borderRadius:22 }}>
                    <Text size={14} weight='bold' color={Colors.shades.white} textAlign='center'>Donate It</Text>
                </TouchableOpacity>
                :<></>}
                <TouchableOpacity 
                disabled={action_loading}
                style={{ flex:3, flexDirection:'row', alignItems:'center', justifyContent:'center', borderRadius:22, backgroundColor:Colors.utility.success, padding:15, opacity:action_loading?0.5:1 }} onPress={() => collectRebate(player_commission_rebate.player_commission_rebate_id)}>
                    {action_loading ?
                    <ActivityIndicator size='small' style={{ marginRight:10 }} color={Colors.shades.white}/>
                    :<></>}
                    <CashIcon color={Colors.shades.white} size={18}  />
                    <Text style={{ marginLeft:15 }} size={14} weight='bold' color={Colors.shades.white}>Claim Rebate (${player_commission_rebate.rebate_amt.toFixed(2)}) Now</Text>
                </TouchableOpacity>
            </View>
            : player_commission_rebate?.status == 'collected' ?
            <View style={{ flexDirection:'row', margin:10 }}>
                <View style={{ flex:1, marginRight:5, padding:15, backgroundColor:Colors.brand.slate, borderRadius:22 }}>
                    <Text size={14} weight='bold' color={Colors.shades.white} textAlign='center'>CLAIMED!</Text>
                </View>
            </View>
            : player_commission_rebate?.status == 'expired' ?
            <View style={{ flexDirection:'row', margin:10 }}>
                <View style={{ flex:1, marginRight:5, padding:15, backgroundColor:Colors.brand.slate, borderRadius:22 }}>
                    <Text size={14} weight='bold' color={Colors.shades.white} textAlign='center'>EXPIRED!</Text>
                </View>
            </View>
            :<></>}

        </View>
    )
}

export default ActivityRebateScreen